module.exports = __webpack_public_path__ + "img/IMG_1899_L_BlackMatted_MockedUp.73fc91c0.jpg";